<template>
  <logged-in-layout>
    <main v-if="ready" :class="$style.container">
      <header>
        <CallInfo
          :activity="activity"
          :info="[]"
          :actions="['add-key-moment', 'play']"
          :class="$style.callInfo" />
      </header>
      <!-- Tabs buttons -->
      <div :class="$style.tabs">
        <button v-if="ownActivity" @click="showActivitySummary" :class="{[$style.active]: tab === 'activity-summary'}"><crm-logo />Log to CRM</button>
        <button @click="showNotepad" :class="{[$style.active]: tab === 'notepad'}"><font-awesome-icon :icon="faPenAlt" />Take Notes</button>
        <button v-if="showLiveCoachTab" @click="showLiveCoach" :class="{[$style.active]: tab === 'livecoach'}"><font-awesome-icon :icon="faBolt" />Live Coach</button>
      </div>
      <!-- Tabs content -->
      <activity-summary v-if="ownActivity" v-show="tab === 'activity-summary'" :activity="activity" />
      <notepad v-show="tab === 'notepad'" :activity="activity" />
      <LiveCoach v-if="activity && showLiveCoachTab" v-show="tab === 'livecoach'" :activity="activity" />
    </main>
  </logged-in-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPenAlt } from '@fortawesome/pro-light-svg-icons/faPenAlt'
import { faBolt } from '@fortawesome/pro-light-svg-icons/faBolt'
import CrmLogo from 'vue-components/crm-logo/crm-logo'
import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
import store from '@/lib/store'
import { jiminnyHost } from '@/helpers/region'
import ActivitySummary from './activity-summary'
import Notepad from './notepad'
import CallInfo from '@/components/shared/CallInfo/CallInfo'
import LiveCoach from './LiveCoach/LiveCoach'

const { mapActions } = createNamespacedHelpers('conference')

export default {
  components: {
    CrmLogo,
    LoggedInLayout,
    FontAwesomeIcon,
    ActivitySummary,
    Notepad,
    CallInfo,
    LiveCoach
  },
  data () {
    return {
      user: store.get('user'),
      team: store.get('team'),
      tab: this.$route.query.tab || null,
      activity: null,
      faPenAlt,
      faBolt,
      isSoftphoneInbound: false,
      isStreamStarted: false,
      channel: null,
      channelPrivateActivity: ''
    }
  },
  computed: {
    ready () {
      return !!this.activity
    },
    ownActivity () {
      return this.activity.organizer.id === this.user.id
    },
    activityChannelName () {
      return `activity.${this.activity.id}`
    },
    privateActivityChannelName () {
      return `private-activity.${this.activity.id}`
    },
    isLiveStreaming () {
      return this.hasLiveStreamFeature && this.ready && (this.isStreamStarted || this.activity?.onAir === 3)
    },
    hasLiveStreamFeature () {
      return !!this.team.features.find(
        (feature) => feature.name === 'VIDEOCOACH'
      )
    },
    showLiveCoachTab () {
      return this.isSoftphoneInbound || (this.isLiveStreaming && this.ownActivity)
    }
  },
  watch: {
    ready: {
      immediate: true,
      handler (isReady) {
        if (isReady) {
          this.subscribeChannel();
          this.subscribeChannelPrivateActivity();
          this.listenEndOfConference();
          this.listenStartOfStreaming();
        }
      }
    }
  },
  mounted () {
    this.retrieveActivity()
  },
  beforeDestroy() {
    this.$pusher.unsubscribe(this.activityChannelName);
    this.$pusher.unsubscribe(this.privateActivityChannelName);
  },
  methods: {
    ...mapActions([
      'setActivity'
    ]),
    showActivitySummary () {
      this.tab = 'activity-summary'
    },
    showNotepad () {
      this.tab = 'notepad'
    },
    showLiveCoach () {
      this.tab = 'livecoach'
    },
    subscribeChannel () {
      this.channel = this.$pusher.subscribe(this.activityChannelName)
    },
    subscribeChannelPrivateActivity () {
      this.channelPrivateActivity = this.$pusher.subscribe(this.privateActivityChannelName)
    },
    listenEndOfConference () {
      this.channel.bind('conference.ended', this.retrieveActivity)
    },
    listenStartOfStreaming () {
      this.channelPrivateActivity.bind('stream-started', () => {
        this.isStreamStarted = true
      })
    },
    async retrieveActivity () {
      try {
        const response = await axios.get(`${jiminnyHost()}/api/v1/activity/${this.$route.params.id}`)
        this.activity = response.data

        this.isSoftphoneInbound = this.activity.type === 'softphone-inbound'

        if (this.isSoftphoneInbound && !this.tab) {
          this.tab = 'notepad'
        }

        if (!this.tab) {
          this.ownActivity
            ? this.showActivitySummary()
            : this.showNotepad()
        }

        this.setActivity(this.activity)
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style module lang="less" src="./meeting.less"></style>



// WEBPACK FOOTER //
// meeting.vue?23c72d64